import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../models/device.view-model";
import {WithDevice} from "../composers/with-device";

export class OptionsStripeProps extends BaseProps {
  LargeCellContent: React.Component;
  SmallCellContent: React.Component;
  MediumCellContent: React.Component;
  smallCellContainerStyle: Object;
  device: DeviceViewModel;
  smallCellProps: BaseProps;
  largeCellProps: BaseProps;
  mediumCellProps: BaseProps;
}

export const OptionsStripe = WithDevice((props: OptionsStripeProps) => {
  const mobileView = props.device.isSmallView;

  return (
    <div className={['option-stripe-container', mobileView ? 'option-stripe-small-view' : ''].join(' ')}>
      {
        !mobileView && props.SmallCellContent && <div className={'option-stripe-small-container'}>
          {
            !!props.SmallCellContent && <props.SmallCellContent {...props.smallCellProps}/>
          }
        </div>
      }
      {
        !mobileView && <div
          className={props.SmallCellContent ? 'option-stripe-large-container' : 'option-stripe-extra-large-container'}>
          {
            !!props.LargeCellContent && <props.LargeCellContent {...props.largeCellProps}/>
          }
        </div>
      }
      <div className={[props.mediumCellProps.containerClassName, 'option-stripe-medium-container'].join(' ')}>
        {
          !!props.MediumCellContent && <props.MediumCellContent {...props.mediumCellProps}/>
        }
      </div>
    </div>
  )
});
